import { createCommand } from '@atlassian/rovo-content-bridge-api';

/**
 * Properties for the Confluence page initialization command.
 */

/**
 * A command sent by a bridge API client to initialize a Confluence page preview with
 * the selected action's data once, after the content surface is ready.
 *
 * @summary {@link CommandProperties.senderId} is requesting {@link CommandProperties.receiverId}
 * to initialize its state from the provided action payload.
 */
export var ConfluencePageInitCommand = createCommand('confluence-page-init-command');